import { apiService } from './api';
import { ApiResponse, CreditTransaction, StripePaymentIntent } from '@/types';

class CreditService {
  async getTransactions(): Promise<ApiResponse<CreditTransaction[]>> {
    try {
      return await apiService.get('/credits/transactions');
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to fetch transactions'
      };
    }
  }

  async createPaymentIntent(creditAmount: number): Promise<ApiResponse<StripePaymentIntent>> {
    try {
      return await apiService.post('/credits/create-payment-intent', { creditAmount });
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to create payment intent'
      };
    }
  }

  async confirmPayment(paymentIntentId: string): Promise<ApiResponse<{ message: string }>> {
    try {
      return await apiService.post('/credits/confirm-payment', { paymentIntentId });
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to confirm payment'
      };
    }
  }

  async getBalance(): Promise<ApiResponse<{ credits: number }>> {
    try {
      return await apiService.get('/credits/balance');
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to fetch balance'
      };
    }
  }
}

export const creditService = new CreditService();